import React, {useState} from 'react';
import './ret.css';
import { Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

const Pannelsam=()=>{

return(        
    <>
{isMobile ? 
    <div>
    <div className='morya moryo'>
<p style={{paddingLeft:"5px"}}>문턱 넘기</p>
<Link to='/jika' className='aheri mdonn'>
    <span className='mpcan'>+</span>
</Link>
</div>
<div className='moryo'>
    <div className='maniyo'>
        <Link to="/jika" className='aheri'>
        <div className='yunjin'><img  style={{backgroundImage : `url(${process.env.PUBLIC_URL+'/inda/'+'illust.png'})`}}/></div>
        <p className='myuntil'>일러스트</p>
        <div className='mreyo'><p>이미지와 영상을 만들고 편집하기</p></div>
        </Link>
    </div>
    <div className='maniyo'>
        <Link to="/jika" className='aheri'>
        <div className='yunjin'><img  style={{backgroundImage : `url(${process.env.PUBLIC_URL+'/inda/'+'analy.png'})`}}/></div>
        <p className='myuntil'>데이터분석</p>
        <div className='mreyo'><p>파이썬으로 데이터로 놀기</p></div>
        </Link>
    </div>
    <div className='maniyo'>
        <Link to="/jika" className='aheri'>
        <div className='yunjin'><img  style={{backgroundImage : `url(${process.env.PUBLIC_URL+'/inda/'+'thesis.png'})`}}/></div>
        <p className='myuntil'>논문</p>
        <div className='mreyo'><p>논문 형식을 간파하기</p></div>
        </Link>
    </div>
    <div className='maniyo'>
        <Link to="/jika" className='aheri'>
        <div className='yunjin'><img  style={{backgroundImage : `url(${process.env.PUBLIC_URL+'/inda/'+'writing_pic.png'})`}}/></div>
        <p className='myuntil'>글쓰기</p>
        <div className='mreyo'><p>창의력과 논리력을 뽐내기</p></div>
        </Link>
    </div>
   
</div></div> : 
<div className='orya11'>
    <div className='orya oryo'><p>문턱 넘기</p><Link to='/jika' className='aheri donn'><span className='pcan'>+</span></Link></div>
<div className='oryo'>
    <div className='aniyo'>
        <Link to="/jika" className='aheri'>
        <div className='yunjin'><img  style={{backgroundImage : `url(${process.env.PUBLIC_URL+'/inda/'+'illust.png'})`}}/></div>
        <p className='greps'>일러스트</p>
        <div className='greyo'><p>이미지와 영상을 만들고 편집하기</p></div>
        </Link>
    </div>
    <div className='aniyo'>
        <Link to="/jika" className='aheri'>
        <div className='yunjin'><img  style={{backgroundImage : `url(${process.env.PUBLIC_URL+'/inda/'+'analy.png'})`}}/></div>
        <p className='greps'>데이터분석</p>
        <div className='greyo'><p>파이썬으로 데이터로 놀기</p></div>
        </Link>
    </div>
    <div className='aniyo'>
        <Link to="/jika" className='aheri'>
        <div className='yunjin'><img  style={{backgroundImage : `url(${process.env.PUBLIC_URL+'/inda/'+'thesis.png'})`}}/></div>
        <p className='greps'>논문</p>
        <div className='greyo'><p>논문 형식을 간파하기</p></div>
        </Link>
    </div>
    <div className='aniyo'>
        <Link to="/jika" className='aheri'>
        <div className='yunjin'><img  style={{backgroundImage : `url(${process.env.PUBLIC_URL+'/inda/'+'writing_pic.png'})`}}/></div>
        <p className='greps'>글쓰기</p>
        <div className='greyo'><p>창의력과 논리력을 뽐내기</p></div>
        </Link>
    </div>
   
</div> 
</div>
}
</>
    );
};

export default Pannelsam;